export interface LoadingColors {
  darkColor: string;
  lightColor: string;
}

export type LoadingColorsVariant =
  | 'spruce-green'
  | 'spruce-yellow'
  | 'spruce-red'
  | 'zillow-blue'
  | 'zillow-yellow'
  | 'zillow-red';

const VARIANT_TO_COLORS: Record<LoadingColorsVariant, LoadingColors> = {
  'spruce-green': { darkColor: '#00584E', lightColor: '#5CBCB7' },
  'spruce-yellow': { darkColor: '#C88205', lightColor: '#FFF6A1' },
  'spruce-red': { darkColor: '#C90000', lightColor: '#FA8555' },
  'zillow-blue': { darkColor: '#0041D9', lightColor: '#65B4FF' },
  'zillow-yellow': { darkColor: '#F08B00', lightColor: '#FFC752' },
  'zillow-red': { darkColor: '#AC001E', lightColor: '#FF7F73' },
};

export const resolveLoadingColorsByVariant = (variant?: LoadingColorsVariant): LoadingColors => {
  const normalizedVariant = variant ?? 'spruce-green';
  return VARIANT_TO_COLORS[normalizedVariant] ?? VARIANT_TO_COLORS['spruce-green'];
};
